import type { CampaignLiveData } from './live-fragment.service';

const BASE: CampaignLiveData = {
  raised: 10_023_400, // £100,234 in minor units
  donorCount: 1247,
  updatedAt: new Date().toISOString(),
};

export function mockLiveDataFor(campaignId: string): CampaignLiveData {
  const hash = campaignId.split('').reduce((a, c) => a + c.charCodeAt(0), 0);
  return {
    raised: BASE.raised + ((hash * 1234) % 10000),
    donorCount: BASE.donorCount + (hash % 50),
    updatedAt: new Date().toISOString(),
  };
}
